import { defineStore } from 'pinia';

export interface User {
  userId: string;
  userNum: string;
  isDev: boolean;
}

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null as User | null,
    isAuthenticated: false,
  }),
  actions: {
    login(user: User) {
      this.user = user;
      this.isAuthenticated = true;
    },
    logout() {
      this.user = null;
      this.isAuthenticated = false;
    },
    resetState() {
      this.user = null
      this.isAuthenticated = false
    }
  },
});